import { Helmet } from "react-helmet-async";
import HeroCampaign from "@/components/home/HeroCampaign";
import ValueStrip from "@/components/home/ValueStrip";
import RecommendedPair from "@/components/home/RecommendedPair";
import LectureGrid from "@/components/home/LectureGrid";
import TopicRouter from "@/components/home/TopicRouter";
import ManifestoStrip from "@/components/home/ManifestoStrip";
import KnygynasStrip from "@/components/home/KnygynasStrip";
import ZemelapisStrip from "@/components/home/ZemelapisStrip";
import SisterProjectsStrip from "@/components/home/SisterProjectsStrip";
import TestimonialsStrip from "@/components/home/TestimonialsStrip";
import NewsletterToliau from "@/components/home/NewsletterToliau";
import IntlHome from "@/components/intl/IntlHome";
import ZemelapisHome from "./ZemelapisHome";
import MetuZemelapisSoon from "./MetuZemelapisSoon";
import { metuZemelapisVisible } from "@/lib/launchFlags";
import { isZemelapisHost, useLang } from "@/i18n";

const Pagrindinis = () => {
  const { market, t, canonicalBase } = useLang();

  if (isZemelapisHost()) return metuZemelapisVisible() ? <ZemelapisHome /> : <MetuZemelapisSoon />;

  if (market === "intl") {
    return (
      <div className="relative bg-cream">
        <Helmet>
          <title>{t("home.title")}</title>
          <meta name="description" content={t("home.description")} />
          <meta property="og:title" content={t("home.ogTitle")} />
          <meta property="og:description" content={t("home.ogDescription")} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`${canonicalBase}/`} />
          <meta property="og:locale" content="en_US" />
          <meta name="twitter:card" content="summary_large_image" />
          <link rel="canonical" href={`${canonicalBase}/`} />
        </Helmet>
        <IntlHome />
      </div>
    );
  }

  return (
    <div className="relative bg-cream">
      <Helmet>
        <title>Laimės Dieta | Saviugdos platforma moterims</title>
        <meta
          name="description"
          content="Laimės Dieta — saviugdos platforma moterims. Audio pamokos apie santykius, sprendimus, save. Knygynas, meditacijos, bendruomenė."
        />
        <meta property="og:title" content="Laimės Dieta | Saviugdos platforma" />
        <meta property="og:description" content="Audio pamokos apie santykius, sprendimus, save. Žemė pilna dangaus." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.laimesdieta.lt/" />
        <meta property="og:image" content="https://www.laimesdieta.lt/images/og-cover-2026-06-24.jpg" />
        <meta property="og:image:secure_url" content="https://www.laimesdieta.lt/images/og-cover-2026-06-24.jpg" />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="lt_LT" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://www.laimesdieta.lt/images/og-cover-2026-06-24.jpg" />
        <link rel="canonical" href="https://www.laimesdieta.lt/" />
      </Helmet>

      <HeroCampaign />
      <ZemelapisStrip />
      <TopicRouter />
      <LectureGrid />
      <RecommendedPair />
      <ManifestoStrip />
      <TestimonialsStrip />
      <KnygynasStrip />
      <ValueStrip />
      <SisterProjectsStrip />
      <NewsletterToliau />
    </div>
  );
};

export default Pagrindinis;
